<div class="main" *ngIf="matIconName && subTitle && title">
  <mat-icon>{{ matIconName }}</mat-icon>

  <div class="texts">
    <div class="sub-title">{{ subTitle }}</div>
    <h2>
      {{ title }}
    </h2>
  </div>
</div>
